import type { ChartPointShape } from "@/utils/transactionRecord";
import type { FC, SVGAttributes } from "react";

export type ChartPointProps = {
  cx: number;
  cy: number;
  fill: string;
  fillOpacity?: number;
  shape: ChartPointShape;
  size?: number;
  stroke?: string;
} & Pick<
  SVGAttributes<SVGElement>,
  "onClick" | "onMouseDown" | "onMouseEnter" | "onMouseLeave" | "style"
>;

const CORNER_RADIUS_RATIO = 0.2;

export const ChartPoint: FC<ChartPointProps> = ({
  cx,
  cy,
  fill,
  fillOpacity = 1,
  onClick,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  shape,
  size = 4,
  stroke = "none",
  style,
}) => {
  const commonProps = {
    fill,
    fillOpacity,
    onClick,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    stroke,
    style,
  };
  const cornerRadius = Math.max(1, size * CORNER_RADIUS_RATIO);

  if (shape === "square") {
    return (
      <rect
        x={cx - size}
        y={cy - size}
        width={size * 2}
        height={size * 2}
        rx={cornerRadius}
        ry={cornerRadius}
        {...commonProps}
      />
    );
  }

  if (shape === "triangle") {
    return (
      <polygon
        points={`${cx},${cy - size} ${cx - size},${cy + size} ${cx + size},${cy + size}`}
        strokeLinejoin="round"
        {...commonProps}
      />
    );
  }

  return (
    <rect
      x={cx - size}
      y={cy - size}
      width={size * 2}
      height={size * 2}
      rx={cornerRadius}
      ry={cornerRadius}
      transform={`rotate(45, ${cx}, ${cy})`}
      {...commonProps}
    />
  );
};
